<template>
  <NuxtLayout name="search-basic-layout">
    <SpaceOverview class="mx-auto pc:pt-[20px] pc:max-w-[90%] pc:px-[8%]"
                   :space-id="Number(route.params.spaceid)"
                   :space-info-data="spaceInfoObj"></SpaceOverview>
  </NuxtLayout>
</template>
<script setup
        lang="ts">
definePageMeta({
  name: 'space-detail',
  title: '空間介紹'
})

import SpaceOverview from "@/components/SpaceDetail/SpaceOverview.vue";
import {getSpaceInfo} from "~/api/space";
import {useGoTo} from "~/composables/useGoTo";
import {useBasicLayoutStore} from "~/stores/basicLayout";
import {tuneCrossDay} from "~/utils/newPriceTool";

const route = useRoute();
const {goHome} = useGoTo();
const basicLayoutStore = useBasicLayoutStore();


const spaceInfoObj = useState('spaceInfoObj', () => null)


function setSeoMeta(seoMeta) {
  // const config = useRuntimeConfig();
  // const webUrl = config.public.webUrl;
  useSeoMeta(seoMeta)
  /* useHead({
     link: [
       //   要固定一個頁面當最主要的，讓seo分數累積在這個頁面
       {rel: 'canonical', href: `${webUrl}/space/7209522916189`}
     ],
   })*/
}

function getCategoryNamesString(categories) {
  categories = categories || []
  return categories.map(category => category.name).join(' ')
}

async function handleSpaceInfo() {
  const picUrl = import.meta.env.VITE_APP_BASE_IMG_URL
  const typeCategoryId = import.meta.env.VITE_APP_BASE_TYPE_CATEGORY_ID
  const usageCategoryId = import.meta.env.VITE_APP_BASE_USAGE_CATEGORY_ID

  try {
    const {data: SpaceInfoData} = await useAsyncData('getSpaceInfo', () => getSpaceInfo(Number(route.params.spaceid), goHome));

    if (SpaceInfoData.value) {
      spaceInfoObj.value = SpaceInfoData.value
      basicLayoutStore.setBreadcrumb(spaceInfoObj.value.name)


      setSeoMeta({
        title: `${SpaceInfoData.value.brand_name} ${SpaceInfoData.value.name}｜線上預約！空間便利店場地租借平台`,
        description: SpaceInfoData.value.introduction||'場地租借要便利，就在空間便利店。一分鐘線上預訂，即時確認，方便又安心。場地租借、活動空間、會議室，各種場地一步搞定',
        keywords: `${getCategoryNamesString(SpaceInfoData.value.categories[Number(typeCategoryId)])} ${getCategoryNamesString(SpaceInfoData.value.categories[Number(usageCategoryId)])}`,
        ogTitle: `${SpaceInfoData.value.name}｜線上預約！空間便利店場地租借平台`,
        ogDescription: SpaceInfoData.value.introduction||'場地租借要便利，就在空間便利店。一分鐘線上預訂，即時確認，方便又安心。場地租借、活動空間、會議室，各種場地一步搞定',
        ogImage: `${picUrl}${SpaceInfoData.value.photos[0].url}`,
        ogImageAlt: `${SpaceInfoData.value.name}｜線上預約！空間便利店場地租借平台`
      })
      /// space_usage_status 日期排序
      spaceInfoObj.value.space_usage_status.sort((a, b) => new Date(a.date) - new Date(b.date))
      spaceInfoObj.value.accessories.forEach(accessory => {
        accessory.ellipsis = true
        accessory.selected = false
      })
    }
  } catch (error) {
    console.log(error)
  }
}

// SSR 取得空間資料
if (Number(route.params.spaceid)) {
  handleSpaceInfo()
}

</script>
<style scoped
       lang="scss">


</style>
